<div class="dialog-content modify-exam-clothes-dialog-content">
  <!--title 標題-->
  <h1 class="dialog-title">
    {{ 'modify-exam-clothes-dialog.title' | translate }}
  </h1>

  <div class="dialog-scroll-content">
    <!--健檢服-->
    <div class="input-block">
      <label class="input-title">{{
        'modify-exam-clothes-dialog.select-size' | translate
      }}</label>
      <mat-radio-group [(ngModel)]="selectedClothesSize">
        @for (size of clothesSizes; track size.uno) {
          <mat-radio-button [value]="size.uno">{{
            size.noDesc
          }}</mat-radio-button>
        }
      </mat-radio-group>
      @if (showError && !selectedClothesSize) {
        <mat-error class="input-error-msg">{{
          'error.size-error.required' | translate
        }}</mat-error>
      }
    </div>
    @if (
      sharedStorageService.get('userPlanRequest')?.gender ===
      API_PARAMS.GENDER.MALE
    ) {
      <div class="input-block cloth-block">
        <div class="input-cloth-group">
          <img
            class="img-cloth"
            width="200"
            src="assets/img/img-male-cloth.png"
            alt=""
          />
          <img width="295" src="assets/img/img-male-cloth-size.png" alt="" />
        </div>
        <div class="input-cloth-group">
          <img
            class="img-cloth cloth-size-l"
            width="200"
            src="assets/img/img-pants-l.png"
            alt=""
          />
          <img
            class="img-cloth cloth-size-s"
            width="200"
            src="assets/img/img-pants-s.png"
            alt=""
          />
          <img width="295" src="assets/img/img-male-pants-size.png" alt="" />
        </div>
      </div>
      <div class="input-block cloth-block">
        <div class="input-cloth-group">
          <img
            class="img-size-recommand-l"
            width="530"
            src="assets/img/img-male-size-recommand-l.png"
            alt=""
          />
          <img
            class="img-size-recommand-s"
            width="590"
            src="assets/img/img-male-size-recommand-s.png"
            alt=""
          />
        </div>
      </div>
    } @else {
      <div class="input-block cloth-block">
        <div class="input-cloth-group">
          <img
            class="img-cloth"
            width="200"
            src="assets/img/img-female-cloth.png"
            alt=""
          />
          <img width="295" src="assets/img/img-female-cloth-size.png" alt="" />
        </div>
        <div class="input-cloth-group">
          <img
            class="img-cloth cloth-size-l"
            width="200"
            src="assets/img/img-pants-l.png"
            alt=""
          />
          <img
            class="img-cloth cloth-size-s"
            width="200"
            src="assets/img/img-pants-s.png"
            alt=""
          />
          <img width="295" src="assets/img/img-female-pants-size.png" alt="" />
        </div>
      </div>
      <div class="input-block cloth-block">
        <div class="input-cloth-group">
          <img
            class="img-size-recommand-l"
            width="530"
            src="assets/img/img-female-size-recommand-l.png"
            alt=""
          />
          <img
            class="img-size-recommand-s"
            width="590"
            src="assets/img/img-female-size-recommand-s.png"
            alt=""
          />
        </div>
      </div>
    }
  </div>

  <div class="dialog-btn-block">
    <button
      mat-button
      class="btn-outline-primary btn-size-l"
      (click)="closeDialog()"
      type="button"
    >
      {{ 'common.button.cancel' | translate }}
    </button>
    <button
      mat-button
      class="btn-fill-primary btn-size-l"
      (click)="onSubmit()"
      type="button"
    >
      {{ 'common.button.save-changes' | translate }}
    </button>
  </div>
</div>
